import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-17503fc4")

_pushScopeId("data-v-17503fc4")
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SearchNavBar = _resolveComponent("SearchNavBar")
  const _component_OSelectButton = _resolveComponent("OSelectButton")
  const _component_InventoryListItem = _resolveComponent("InventoryListItem")
  const _component_ListWrapper = _resolveComponent("ListWrapper")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_SearchNavBar, {
      ref: "searchNavBar",
      search: _ctx.searchText,
      "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchText = $event)),
      title: "Inventário",
      navigation: "menu",
      "search-placeholder": _ctx.searchPlaceholder
    }, null, 8, ["search", "search-placeholder"]),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_OSelectButton, {
        modelValue: _ctx.viewModeComputed,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.viewModeComputed = $event)),
        class: "view-mode",
        options: _ctx.viewModeOptions,
        "option-label": "name",
        "option-value": "value",
        disabled: _ctx.loading,
        "data-test": "viewMode"
      }, null, 8, ["modelValue", "options", "disabled"]),
      _createVNode(_component_ListWrapper, {
        records: _ctx.inventories,
        loading: _ctx.loading,
        error: _ctx.error,
        "error-msg": "Não foi possível carregar seu inventário.",
        "reload-cb": _ctx.loadInventories
      }, {
        default: _withId((slotProps) => [
          _createVNode(_component_InventoryListItem, {
            inventory: slotProps.record,
            onClick: ($event: any) => (_ctx.openSummary(slotProps.record))
          }, null, 8, ["inventory", "onClick"])
        ]),
        _: 1
      }, 8, ["records", "loading", "error", "reload-cb"])
    ])
  ]))
})